import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, normalizeStyle as _normalizeStyle, vModelRadio as _vModelRadio, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/admin-img/date-blue.svg'
import _imports_1 from '@/assets/images/admin-img/tags-close-icon.svg'
import _imports_2 from '@/assets/images/admin-img/pdf-icon.svg'
import _imports_3 from '@/assets/images/admin-img/download-icon.svg'
import _imports_4 from '@/assets/images/admin-img/light_delete-outline.svg'
import _imports_5 from '@/assets/images/admin-img/light_w-outline.svg'
import _imports_6 from '@/assets/images/admin-img/hired.svg'
import _imports_7 from '@/assets/images/admin-img/reject.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "admin-mid-container" }
const _hoisted_3 = {
  class: "admin-custom-row admin-page-row",
  id: "leftMenuSlideBox"
}
const _hoisted_4 = { class: "admin-right-sidebar-in" }
const _hoisted_5 = { class: "admin-right-sidebar-in-top" }
const _hoisted_6 = { class: "admin-custom-row" }
const _hoisted_7 = { class: "admin-right-sidebar-in-top-left" }
const _hoisted_8 = { class: "admin-page-type-links" }
const _hoisted_9 = { class: "admin-right-sidebar-in-top-right" }
const _hoisted_10 = { class: "admin-right-sidebar-in-top-right-top" }
const _hoisted_11 = { class: "admin-search-box" }
const _hoisted_12 = { class: "date-filter-icon" }
const _hoisted_13 = { class: "date-filter-dropdown-in" }
const _hoisted_14 = { class: "custom-date-picker" }
const _hoisted_15 = { class: "action-buttons" }
const _hoisted_16 = { class: "criteria-button" }
const _hoisted_17 = { class: "selected-tags-section" }
const _hoisted_18 = { class: "admin-right-sidebar-in-top-right-btm select-all-positions" }
const _hoisted_19 = { class: "select-all-checkbox" }
const _hoisted_20 = { class: "admin-checkbox-input" }
const _hoisted_21 = { class: "tags" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 3 }
const _hoisted_26 = {
  key: 4,
  class: "tags-status"
}
const _hoisted_27 = {
  key: 0,
  class: "delete-all-btn-link"
}
const _hoisted_28 = {
  key: 1,
  class: "delete-all-btn-link"
}
const _hoisted_29 = {
  key: 2,
  class: "re-calculator-ai-btn"
}
const _hoisted_30 = { class: "export-dropdown-list" }
const _hoisted_31 = { class: "admin-checkbox-input" }
const _hoisted_32 = { for: "export_item_1" }
const _hoisted_33 = { class: "admin-checkbox-input" }
const _hoisted_34 = { for: "export_item_2" }
const _hoisted_35 = { class: "admin-checkbox-input" }
const _hoisted_36 = { for: "export_item_3" }
const _hoisted_37 = { class: "admin-checkbox-input" }
const _hoisted_38 = { for: "export_item_4" }
const _hoisted_39 = { class: "admin-checkbox-input" }
const _hoisted_40 = { for: "export_item_5" }
const _hoisted_41 = { class: "admin-checkbox-input" }
const _hoisted_42 = { for: "export_item_6" }
const _hoisted_43 = { class: "admin-checkbox-input" }
const _hoisted_44 = { for: "export_item_7" }
const _hoisted_45 = { class: "admin-checkbox-input" }
const _hoisted_46 = { for: "export_item_8" }
const _hoisted_47 = { class: "export-dropdown-btns" }
const _hoisted_48 = {
  class: "admin-item-list-section-in",
  ref: "scrollWrapper",
  "data-simplebar": ""
}
const _hoisted_49 = { class: "admin-item-list-section-scroll" }
const _hoisted_50 = { class: "admin-item-list-top" }
const _hoisted_51 = { class: "admin-item-list-row" }
const _hoisted_52 = { class: "admin-item-checkbox" }
const _hoisted_53 = { class: "admin-checkbox-input" }
const _hoisted_54 = { class: "admin-item-image" }
const _hoisted_55 = { class: "join-team-actions" }
const _hoisted_56 = { class: "admin-item-list-btm" }
const _hoisted_57 = { class: "admin-item-box-top" }
const _hoisted_58 = { class: "admin-item-list-row" }
const _hoisted_59 = {
  key: 0,
  class: "new-message-point"
}
const _hoisted_60 = { class: "admin-item-checkbox" }
const _hoisted_61 = { class: "admin-checkbox-input" }
const _hoisted_62 = ["id", "onChange", "checked"]
const _hoisted_63 = ["for"]
const _hoisted_64 = { class: "admin-item-image" }
const _hoisted_65 = { class: "sm-img" }
const _hoisted_66 = ["src"]
const _hoisted_67 = { class: "admin-item-team-name" }
const _hoisted_68 = { class: "limited-text text-limit" }
const _hoisted_69 = { class: "admin-item-team-email" }
const _hoisted_70 = { class: "admin-item-join-team-designation text-limit" }
const _hoisted_71 = { class: "admin-item-team-date" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { class: "admin-item-ai-score" }
const _hoisted_74 = ["onClick"]
const _hoisted_75 = { class: "join-team-actions" }
const _hoisted_76 = { class: "admin-action-link" }
const _hoisted_77 = ["onClick"]
const _hoisted_78 = ["onClick"]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = { class: "status-select-box" }
const _hoisted_81 = ["id", "onChange", "onClick"]
const _hoisted_82 = ["selected"]
const _hoisted_83 = ["selected"]
const _hoisted_84 = ["selected"]
const _hoisted_85 = ["selected"]
const _hoisted_86 = {
  key: 0,
  class: "admin-item-box-btm join-team-details"
}
const _hoisted_87 = { class: "join-team-details-box" }
const _hoisted_88 = { class: "join-team-tabs-details" }
const _hoisted_89 = { class: "join-team-tabs-details-left" }
const _hoisted_90 = { class: "sender-img" }
const _hoisted_91 = ["src"]
const _hoisted_92 = { class: "join-team-tabs-details-right" }
const _hoisted_93 = { class: "sender-info" }
const _hoisted_94 = { class: "span-txt" }
const _hoisted_95 = { class: "span-txt" }
const _hoisted_96 = { class: "span-txt" }
const _hoisted_97 = { class: "span-txt" }
const _hoisted_98 = { class: "span-txt" }
const _hoisted_99 = { class: "li-item-50" }
const _hoisted_100 = { class: "label-item-box" }
const _hoisted_101 = { class: "label-item-box" }
const _hoisted_102 = { class: "span-txt" }
const _hoisted_103 = ["onClick"]
const _hoisted_104 = { class: "full-desc" }
const _hoisted_105 = { class: "span-txt" }
const _hoisted_106 = { class: "attachment-box" }
const _hoisted_107 = { class: "attachment-info" }
const _hoisted_108 = ["onClick"]
const _hoisted_109 = { class: "conversation-history-count-section" }
const _hoisted_110 = { class: "mail-ul-actions" }
const _hoisted_111 = ["onClick"]
const _hoisted_112 = ["onClick"]
const _hoisted_113 = { class: "join-team-tabs" }
const _hoisted_114 = { class: "join-team-tabs-items-row join-team-tabs-hd" }
const _hoisted_115 = { class: "join-team-items join-team-items-date" }
const _hoisted_116 = { class: "join-team-items join-team-items-from" }
const _hoisted_117 = { class: "join-team-items join-team-items-to" }
const _hoisted_118 = { class: "join-team-items join-team-items-sub" }
const _hoisted_119 = { class: "join-team-items join-team-items-actions" }
const _hoisted_120 = { class: "join-team-tabs-content" }
const _hoisted_121 = ["onClick"]
const _hoisted_122 = { class: "join-team-tabs-box-top" }
const _hoisted_123 = { class: "join-team-tabs-items-row" }
const _hoisted_124 = { class: "join-team-items join-team-items-date" }
const _hoisted_125 = { class: "join-team-items join-team-items-from" }
const _hoisted_126 = { class: "join-team-items join-team-items-to" }
const _hoisted_127 = { class: "join-team-items join-team-items-sub" }
const _hoisted_128 = { class: "join-team-items join-team-items-actions" }
const _hoisted_129 = { class: "admin-action-link" }
const _hoisted_130 = ["onClick"]
const _hoisted_131 = { class: "join-team-tabs-box-btm" }
const _hoisted_132 = { class: "join-team-email-content" }
const _hoisted_133 = { class: "join-team-email-item" }
const _hoisted_134 = { class: "join-team-email-date" }
const _hoisted_135 = { class: "join-team-email-item" }
const _hoisted_136 = { class: "join-team-email-item" }
const _hoisted_137 = { class: "join-team-email-full-message" }
const _hoisted_138 = ["innerHTML"]
const _hoisted_139 = { class: "mail-ul-actions" }
const _hoisted_140 = ["onClick"]
const _hoisted_141 = ["onClick"]
const _hoisted_142 = { class: "admin-pagination-section" }
const _hoisted_143 = { class: "custom-row" }
const _hoisted_144 = { class: "item-show-selectbox" }
const _hoisted_145 = {
  key: 0,
  class: "admin-pagination",
  id: "paginationBox"
}
const _hoisted_146 = ["onClick"]
const _hoisted_147 = { key: 1 }
const _hoisted_148 = { class: "admin-site-footer" }
const _hoisted_149 = { class: "container" }
const _hoisted_150 = {
  class: "modal fade confirmation-popup",
  id: "deletePop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_151 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_152 = { class: "modal-content" }
const _hoisted_153 = { class: "confirmation-popup-mid" }
const _hoisted_154 = { class: "confirmation-popup-btm" }
const _hoisted_155 = {
  id: "popNoBtn",
  class: "admin-btn-outline-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_156 = {
  class: "modal fade confirmation-popup",
  id: "followupPop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "followupModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_157 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_158 = { class: "modal-content followupPop" }
const _hoisted_159 = { class: "confirmation-popup-btm" }
const _hoisted_160 = {
  class: "modal fade confirmation-popup",
  id: "HiredPop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "HiredModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_161 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_162 = { class: "modal-content HiredPop" }
const _hoisted_163 = { class: "confirmation-popup-btm" }
const _hoisted_164 = {
  class: "modal fade confirmation-popup",
  id: "rejectedPop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "rejectedModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_165 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_166 = { class: "modal-content rejectedPop" }
const _hoisted_167 = { class: "confirmation-popup-btm" }
const _hoisted_168 = {
  class: "modal fade reply-popup",
  id: "replyPop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "replyModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_169 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_170 = { class: "modal-content" }
const _hoisted_171 = { class: "reply-form" }
const _hoisted_172 = { class: "admin-input-field" }
const _hoisted_173 = { class: "admin-input-field" }
const _hoisted_174 = { class: "admin-input-field" }
const _hoisted_175 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_176 = { class: "admin-input-field" }
const _hoisted_177 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_178 = { class: "admin-input-field-submit" }
const _hoisted_179 = ["disabled"]
const _hoisted_180 = {
  type: "button",
  class: "dummy-btn",
  "data-bs-dismiss": "modal",
  ref: "dummyButton",
  style: {"display":"none"}
}
const _hoisted_181 = {
  class: "modal fade ai-score-popup",
  id: "aiScorePop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "replyModalLabel",
  "aria-hidden": "true"
}
const _hoisted_182 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_183 = { class: "modal-content" }
const _hoisted_184 = { class: "ai-score-popup-top" }
const _hoisted_185 = { class: "ai-score-popup-top-left" }
const _hoisted_186 = { class: "person-ai-score-info" }
const _hoisted_187 = { class: "person-ai-score-img" }
const _hoisted_188 = ["src"]
const _hoisted_189 = { class: "person-ai-score-content" }
const _hoisted_190 = { class: "person-ai-score-content-name" }
const _hoisted_191 = { class: "person-ai-score-content-job" }
const _hoisted_192 = { class: "person-ai-score-content-location" }
const _hoisted_193 = { class: "ai-score-popup-top-right" }
const _hoisted_194 = { class: "ai-score-status-chart" }
const _hoisted_195 = ["stroke-dasharray"]
const _hoisted_196 = {
  x: "18",
  y: "20.35",
  class: "percentage"
}
const _hoisted_197 = { class: "ai-score-status-content" }
const _hoisted_198 = { class: "ai-score-popup-bottom" }
const _hoisted_199 = { class: "ai-score-popup-tabs-section" }
const _hoisted_200 = { class: "ai-score-popup-tabs-top" }
const _hoisted_201 = {
  class: "nav",
  id: "myTab",
  role: "tablist"
}
const _hoisted_202 = { role: "presentation" }
const _hoisted_203 = {
  class: "active",
  id: "score-override-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#scoreOverride",
  type: "button",
  role: "tab",
  "aria-controls": "scoreOverride",
  "aria-selected": "true"
}
const _hoisted_204 = { role: "presentation" }
const _hoisted_205 = {
  class: "",
  id: "score-history-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#scoreHistory",
  type: "button",
  role: "tab",
  "aria-controls": "scoreHistory",
  "aria-selected": "false"
}
const _hoisted_206 = { role: "presentation" }
const _hoisted_207 = {
  class: "",
  id: "score-resume-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#scoreResume",
  type: "button",
  role: "tab",
  "aria-controls": "scoreResume",
  "aria-selected": "false"
}
const _hoisted_208 = { role: "presentation" }
const _hoisted_209 = {
  class: "",
  id: "score-criteria-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#scoreCriteria",
  type: "button",
  role: "tab",
  "aria-controls": "scoreCriteria",
  "aria-selected": "false"
}
const _hoisted_210 = { class: "ai-score-popup-tabs-btm" }
const _hoisted_211 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_212 = {
  class: "tab-pane fade show active",
  id: "scoreOverride",
  role: "tabpanel",
  "aria-labelledby": "score-override-tab"
}
const _hoisted_213 = { class: "score-override-tab-details" }
const _hoisted_214 = { class: "score-override-tab-details-step-1-left" }
const _hoisted_215 = { class: "score-summary-desc" }
const _hoisted_216 = { class: "score-override-tab-details-step-1-right" }
const _hoisted_217 = { class: "score-summary-items-slider" }
const _hoisted_218 = ["onClick"]
const _hoisted_219 = {
  ref: "scrollWrapper",
  class: "ai-pop-scroll-sm-outr",
  "data-simplebar": ""
}
const _hoisted_220 = { class: "ai-pop-scroll-sm" }
const _hoisted_221 = { class: "scores-edit-box-left" }
const _hoisted_222 = { class: "scores-edit-box-left-top" }
const _hoisted_223 = { class: "scores-edit-name" }
const _hoisted_224 = { class: "scores-edit-percentage" }
const _hoisted_225 = { class: "scores-edit-box-right" }
const _hoisted_226 = { class: "scores-edit-icon-list" }
const _hoisted_227 = ["onClick"]
const _hoisted_228 = { class: "scores-edit-box-weight" }
const _hoisted_229 = {
  ref: "overallScoreChart",
  width: "400",
  height: "300"
}
const _hoisted_230 = { class: "score-interviewer-name" }
const _hoisted_231 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_232 = {
  ref: "scrollWrapper",
  class: "ai-pop-scroll-sm-edit-outr",
  "data-simplebar": ""
}
const _hoisted_233 = { class: "ai-pop-scroll-sm-edit" }
const _hoisted_234 = { class: "score-override-edit-reason-section" }
const _hoisted_235 = { class: "score-override-edit-reason" }
const _hoisted_236 = { class: "score-override-edit-reason-top" }
const _hoisted_237 = { class: "score-override-edit-reason-left" }
const _hoisted_238 = { class: "score-override-edit-reason-left-top" }
const _hoisted_239 = { class: "current-score" }
const _hoisted_240 = { class: "score--edit-input" }
const _hoisted_241 = ["value"]
const _hoisted_242 = {
  key: 0,
  class: "error-mesg"
}
const _hoisted_243 = { class: "feedback-summary-textarea" }
const _hoisted_244 = { class: "feedback-summary-textedit" }
const _hoisted_245 = ["value"]
const _hoisted_246 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_247 = ["id"]
const _hoisted_248 = ["onClick", "aria-expanded", "aria-controls"]
const _hoisted_249 = ["id", "aria-labelledby"]
const _hoisted_250 = { class: "accordion-body" }
const _hoisted_251 = { class: "score-override-edit-reason" }
const _hoisted_252 = { class: "score-override-edit-reason-top" }
const _hoisted_253 = { class: "score-override-edit-reason-left" }
const _hoisted_254 = { class: "score-override-edit-reason-left-top" }
const _hoisted_255 = { class: "current-score" }
const _hoisted_256 = { class: "score--edit-input" }
const _hoisted_257 = ["id", "value", "onInput"]
const _hoisted_258 = {
  key: 0,
  class: "error-mesg"
}
const _hoisted_259 = { class: "feedback-summary-textarea" }
const _hoisted_260 = { class: "feedback-summary-textedit" }
const _hoisted_261 = ["onUpdate:modelValue"]
const _hoisted_262 = {
  key: 0,
  class: "score-override-btns"
}
const _hoisted_263 = {
  class: "tab-pane fade",
  id: "scoreHistory",
  role: "tabpanel",
  "aria-labelledby": "score-history-tab"
}
const _hoisted_264 = {
  class: "score-history-tab-details ai-pop-scroll-out",
  ref: "scrollWrapper",
  "data-simplebar": ""
}
const _hoisted_265 = { class: "ai-pop-scroll" }
const _hoisted_266 = { class: "score-history-date" }
const _hoisted_267 = { class: "score-history-descption" }
const _hoisted_268 = {
  key: 1,
  class: "score-history-descption"
}
const _hoisted_269 = {
  class: "tab-pane fade",
  id: "scoreResume",
  role: "tabpanel",
  "aria-labelledby": "score-resume-tab"
}
const _hoisted_270 = {
  class: "score-resume-tab-details ai-pop-scroll-out",
  ref: "scrollWrapper",
  "data-simplebar": ""
}
const _hoisted_271 = { class: "ai-pop-scroll" }
const _hoisted_272 = { class: "score-resume-box-desc" }
const _hoisted_273 = { key: 0 }
const _hoisted_274 = {
  key: 1,
  class: "score-resume-box-skill"
}
const _hoisted_275 = { key: 2 }
const _hoisted_276 = { key: 0 }
const _hoisted_277 = { class: "score-resume-box-date" }
const _hoisted_278 = { key: 1 }
const _hoisted_279 = { class: "score-resume-box-date" }
const _hoisted_280 = { key: 0 }
const _hoisted_281 = { key: 1 }
const _hoisted_282 = { key: 2 }
const _hoisted_283 = { class: "technologies" }
const _hoisted_284 = { class: "score-resume-box-date" }
const _hoisted_285 = { key: 3 }
const _hoisted_286 = { class: "score-resume-box-date" }
const _hoisted_287 = { key: 4 }
const _hoisted_288 = { key: 5 }
const _hoisted_289 = { key: 3 }
const _hoisted_290 = {
  key: 1,
  class: "score-resume-box"
}
const _hoisted_291 = {
  class: "tab-pane fade",
  id: "scoreCriteria",
  role: "tabpanel",
  "aria-labelledby": "score-criteria-tab"
}
const _hoisted_292 = { class: "score-criteria-tab-details" }
const _hoisted_293 = {
  ref: "scrollWrapper",
  class: "ai-pop-scroll-out",
  "data-simplebar": ""
}
const _hoisted_294 = { class: "ai-pop-scroll" }
const _hoisted_295 = { key: 0 }
const _hoisted_296 = ["innerHTML"]
const _hoisted_297 = { class: "score-criteria-pop-version" }
const _hoisted_298 = {
  key: 1,
  class: "score-criteria-box"
}
const _hoisted_299 = {
  class: "modal fade criteria-popup",
  id: "criteriaPop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "criteriaModalLabel",
  "aria-hidden": "true"
}
const _hoisted_300 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_301 = { class: "modal-content" }
const _hoisted_302 = { class: "criteria-pop-mid" }
const _hoisted_303 = { class: "admin-input-field" }
const _hoisted_304 = { class: "label-postion" }
const _hoisted_305 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_306 = { class: "admin-input-field-submit" }
const _hoisted_307 = {
  class: "modal fade confirmation-popup",
  id: "confirmationSubmitPop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "confirmationSubmitModalLabel",
  "aria-hidden": "true"
}
const _hoisted_308 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_309 = { class: "modal-content" }
const _hoisted_310 = { class: "confirmation-popup-mid" }
const _hoisted_311 = { class: "confirmation-popup-btm" }
const _hoisted_312 = {
  class: "modal fade reproduct-aiScore-popup",
  id: "reproductAiScorePopup",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "criteriaModalLabel",
  "aria-hidden": "true"
}
const _hoisted_313 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_314 = { class: "modal-content" }
const _hoisted_315 = { class: "reproduct-aiScore-pop-mid" }
const _hoisted_316 = { class: "reproduct-aiScore-v-list" }
const _hoisted_317 = ["id", "value"]
const _hoisted_318 = ["for"]
const _hoisted_319 = { class: "admin-input-field-submit" }
const _hoisted_320 = ["disabled"]
const _hoisted_321 = { key: 0 }
const _hoisted_322 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adminHeader = _resolveComponent("adminHeader")!
  const _component_adminNavigation = _resolveComponent("adminNavigation")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_ckeditor = _resolveComponent("ckeditor")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_adminHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_adminNavigation),
        _createElementVNode("section", {
          class: "admin-right-sidebar",
          onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.handleOutsideClick && _ctx.handleOutsideClick(...args)))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.constants.JOIN_OUR_TEAM_TEXT), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "allLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'all' }),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchView('all')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.ALL_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.all), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "newApplicationLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'hired' }),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchView('hired')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.HIRED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.hired), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "followUpLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'pending' }),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchView('pending')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.PENDING_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.pending), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "rejectedLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'rejected' }),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchView('rejected')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.REJECTED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.rejected), 1)
                        ], 2)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        id: "seachJoinTeamInput",
                        type: "text",
                        placeholder: "Search",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchedText) = $event)),
                        onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (
                          _ctx.fetchJoinTeams(_ctx.activeTab),
                            _ctx.fetchCounts(_ctx.searchedText),
                            (_ctx.editFormSubmitted = false),
                            (_ctx.selectAll = false),
                            (_ctx.selectedJoinTeams = []),
                            (_ctx.selectAllCandidates = false)
                        ), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.searchedText]
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["date-filter-box", { 'show-date-dropdown': _ctx.showDateDropdown }]),
                      id: "dateFilterDropdown"
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("button", {
                          id: "dateFilterBtn",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleDateDropdown && _ctx.toggleDateDropdown(...args)))
                        }, [...(_cache[83] || (_cache[83] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: ""
                          }, null, -1)
                        ]))])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["date-filter-dropdown", { 'show-custom-date': _ctx.showCustomDate }])
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("a", {
                            href: "#",
                            id: "lastWeeekLink",
                            class: "date-item",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getDateFilteredData('lastWeek')))
                          }, _toDisplayString(_ctx.constants.LAST_WEEK_LINK), 1),
                          _createElementVNode("a", {
                            href: "#",
                            id: "lastMonthLink",
                            class: "date-item",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getDateFilteredData('lastMonth')))
                          }, _toDisplayString(_ctx.constants.LAST_MONTH_LINK), 1),
                          _createElementVNode("a", {
                            href: "#",
                            id: "customDateLink",
                            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => {
                              _ctx.showCustomPicker = true;
                              _ctx.showCustomDate = true;
                            }, ["prevent"]))
                          }, _toDisplayString(_ctx.constants.CUSTOM_DATE_LINK), 1)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          (_ctx.showCustomPicker)
                            ? (_openBlock(), _createBlock(_component_Datepicker, {
                                key: 0,
                                range: "",
                                "enable-time-picker": false,
                                clearable: false,
                                "menu-class-name": "custom-datepicker-menu",
                                inline: true,
                                onRangeStart: _ctx.onRangeStart,
                                onRangeEnd: _ctx.onRangeEnd
                              }, {
                                "action-buttons": _withCtx(() => [
                                  _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("button", {
                                      id: "cancelButton",
                                      class: "cancel-btn",
                                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resetClasses && _ctx.resetClasses(...args)))
                                    }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1),
                                    _createElementVNode("button", {
                                      id: "doneButton",
                                      class: "apply-btn",
                                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleDate()))
                                    }, _toDisplayString(_ctx.constants.DONE_BUTTON), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["onRangeStart", "onRangeEnd"]))
                            : _createCommentVNode("", true)
                        ])
                      ], 2)
                    ], 2),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", {
                        class: "btn_link",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#criteriaPop",
                        id: "criteriaBtn",
                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.openCriteriaModal && _ctx.openCriteriaModal(...args)))
                      }, _toDisplayString(_ctx.constants.CRITERIA_BUTTON), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _withDirectives(_createElementVNode("input", {
                        name: "cssCheckbox",
                        id: "item_1",
                        type: "checkbox",
                        class: "css-checkbox",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectAllCandidates) = $event)),
                        onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAllCandidates && _ctx.toggleSelectAllCandidates(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.selectAllCandidates]
                      ]),
                      _cache[84] || (_cache[84] = _createElementVNode("label", { for: "item_1" }, "Select All", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("ul", null, [
                      (_ctx.selectedJoinTeams.length > 0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.selectedJoinTeams.length) + " entries selected", 1),
                            _createElementVNode("button", {
                              id: "tagCloseBtn",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.selectedJoinTeams = []; _ctx.selectAll = false; _ctx.selectAllCandidates = false;})
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.dateFilter === 'custom')
                        ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.formatCustomDate(_ctx.startDate)) + "-" + _toDisplayString(_ctx.formatCustomDate(_ctx.endDate)), 1),
                            _createElementVNode("button", {
                              id: "tagCloseBtn",
                              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.clearDateFilter && _ctx.clearDateFilter(...args)))
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.dateFilter === 'lastWeek')
                        ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                            _cache[85] || (_cache[85] = _createElementVNode("span", null, "Last Week ", -1)),
                            _createElementVNode("button", {
                              id: "tagCloseBtn",
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (
                              (_ctx.dateFilter = ''),
                                _ctx.fetchJoinTeams(_ctx.activeTab),
                                _ctx.fetchCounts(),
                                (_ctx.limit =20)
                            ))
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.dateFilter === 'lastMonth')
                        ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                            _cache[86] || (_cache[86] = _createElementVNode("span", null, "Last Month", -1)),
                            _createElementVNode("button", {
                              id: "tagCloseBtn",
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (
                              (_ctx.dateFilter = ''),
                                _ctx.fetchJoinTeams(_ctx.activeTab),
                                _ctx.fetchCounts(),
                                (_ctx.limit = 20)
                            ))
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedJoinTeams.length > 1 && _ctx.hasSameStatus())
                        ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                            _withDirectives(_createElementVNode("select", {
                              class: "tags-status-selectbox",
                              onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.handleBulkStatusChange && _ctx.handleBulkStatusChange(...args))),
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.bulkStatusValue) = $event))
                            }, [...(_cache[87] || (_cache[87] = [
                              _createStaticVNode("<option value=\"\" disabled>Select Status</option><option value=\"0\">Pending</option><option value=\"1\">Hired</option><option value=\"2\">Rejected</option><option value=\"4\" disabled>Evaluating</option>", 5)
                            ]))], 544), [
                              [_vModelSelect, _ctx.bulkStatusValue]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.selectedJoinTeams.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("button", {
                          class: "btn_link",
                          id: "deleteAllBtn",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#deletePop",
                          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.setDeleteMode('all')))
                        }, " Delete ")
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedJoinTeams.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("button", {
                          class: "btn_link",
                          id: "downloadAllBtn",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.downloadResume('all')))
                        }, _toDisplayString(_ctx.constants.DOWNLOAD_ALL_BUTTON), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedJoinTeams.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("button", {
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#reproductAiScorePopup",
                          id: "criteriaBtn",
                          class: "btn_link",
                          onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.openReproduceModal && _ctx.openReproduceModal(...args)))
                        }, "Reproduce AI Score")
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["export-dropdown", { 'show-dropdown': _ctx.isExportDropdownOpened}])
                  }, [
                    _createElementVNode("button", {
                      id: "exportBtn",
                      class: "export-dropdown-btn",
                      onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.toggleExportDropdown && _ctx.toggleExportDropdown(...args)))
                    }, _toDisplayString(_ctx.constants.EXPORT_BUTTON), 1),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _createElementVNode("button", {
                            id: "downloadBtn",
                            class: "admin-btn-outline-primary li_file_download_btn",
                            onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.exportToExcel && _ctx.exportToExcel(...args)))
                          }, _toDisplayString(_ctx.constants.DOWNLOAD_BUTTON), 1)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_31, [
                            _withDirectives(_createElementVNode("input", {
                              name: "cssCheckbox",
                              id: "export_item_1",
                              type: "checkbox",
                              class: "css-checkbox",
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.selectAllExportFields) = $event)),
                              onChange: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAllExportFields && _ctx.toggleSelectAllExportFields(...args)))
                            }, null, 544), [
                              [_vModelCheckbox, _ctx.selectAllExportFields]
                            ]),
                            _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.constants.ALL_LINK), 1)
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_33, [
                            _withDirectives(_createElementVNode("input", {
                              name: "cssCheckbox",
                              id: "export_item_2",
                              type: "checkbox",
                              class: "css-checkbox",
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.exportFields.name) = $event)),
                              onChange: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.updateSelectAllExportFields && _ctx.updateSelectAllExportFields(...args)))
                            }, null, 544), [
                              [_vModelCheckbox, _ctx.exportFields.name]
                            ]),
                            _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.constants.NAME_LABEL), 1)
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_35, [
                            _withDirectives(_createElementVNode("input", {
                              name: "cssCheckbox",
                              id: "export_item_3",
                              type: "checkbox",
                              class: "css-checkbox",
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.exportFields.email) = $event)),
                              onChange: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.updateSelectAllExportFields && _ctx.updateSelectAllExportFields(...args)))
                            }, null, 544), [
                              [_vModelCheckbox, _ctx.exportFields.email]
                            ]),
                            _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.constants.EMAIL_LABEL), 1)
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_37, [
                            _withDirectives(_createElementVNode("input", {
                              name: "cssCheckbox",
                              id: "export_item_4",
                              type: "checkbox",
                              class: "css-checkbox",
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.exportFields.designation) = $event)),
                              onChange: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.updateSelectAllExportFields && _ctx.updateSelectAllExportFields(...args)))
                            }, null, 544), [
                              [_vModelCheckbox, _ctx.exportFields.designation]
                            ]),
                            _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.constants.DESIGNATION_LABEL), 1)
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_39, [
                            _withDirectives(_createElementVNode("input", {
                              name: "cssCheckbox",
                              id: "export_item_5",
                              type: "checkbox",
                              class: "css-checkbox",
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.exportFields.reference) = $event)),
                              onChange: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.updateSelectAllExportFields && _ctx.updateSelectAllExportFields(...args)))
                            }, null, 544), [
                              [_vModelCheckbox, _ctx.exportFields.reference]
                            ]),
                            _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.constants.NAME_OF_REFERENCE_LABEL), 1)
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_41, [
                            _withDirectives(_createElementVNode("input", {
                              name: "cssCheckbox",
                              id: "export_item_6",
                              type: "checkbox",
                              class: "css-checkbox",
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.exportFields.description) = $event)),
                              onChange: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.updateSelectAllExportFields && _ctx.updateSelectAllExportFields(...args)))
                            }, null, 544), [
                              [_vModelCheckbox, _ctx.exportFields.description]
                            ]),
                            _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.constants.DESCRIPTION_LABEL), 1)
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_43, [
                            _withDirectives(_createElementVNode("input", {
                              name: "cssCheckbox",
                              id: "export_item_7",
                              type: "checkbox",
                              class: "css-checkbox",
                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.exportFields.status) = $event)),
                              onChange: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.updateSelectAllExportFields && _ctx.updateSelectAllExportFields(...args)))
                            }, null, 544), [
                              [_vModelCheckbox, _ctx.exportFields.status]
                            ]),
                            _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.constants.STATUS_LABEL), 1)
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_45, [
                            _withDirectives(_createElementVNode("input", {
                              name: "cssCheckbox",
                              id: "export_item_8",
                              type: "checkbox",
                              class: "css-checkbox",
                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.exportFields.date) = $event)),
                              onChange: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.updateSelectAllExportFields && _ctx.updateSelectAllExportFields(...args)))
                            }, null, 544), [
                              [_vModelCheckbox, _ctx.exportFields.date]
                            ]),
                            _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.constants.DATE_LABEL), 1)
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_47, [
                            _cache[88] || (_cache[88] = _createElementVNode("button", { class: "admin-btn-outline-primary" }, " Done ", -1)),
                            _createElementVNode("button", {
                              onClick: _cache[42] || (_cache[42] = ($event: any) => {_ctx.exportFields = {
                                image: false,
                                name: false,
                                email: false,
                                designation: false,
                                reference: false,
                                description: false,
                                status: false,
                                date: false,
                              };_ctx.selectAllExportFields = false;}),
                              class: "admin-btn-outline-secondary"
                            }, " Cancel ")
                          ])
                        ])
                      ])
                    ])
                  ], 2)
                ])
              ])
            ]),
            (_ctx.editJoinTeamsData.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([
                'admin-item-list-section admin-join-team-section',
                { 'show-edit-item-outer': _ctx.editFormSubmitted },
              ])
                }, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                              _withDirectives(_createElementVNode("input", {
                                name: "cssCheckbox",
                                id: "selectAll",
                                type: "checkbox",
                                class: "css-checkbox",
                                onChange: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args))),
                                "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.selectAll) = $event))
                              }, null, 544), [
                                [_vModelCheckbox, _ctx.selectAll]
                              ]),
                              _cache[89] || (_cache[89] = _createElementVNode("label", { for: "selectAll" }, null, -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.constants.IMAGE_LABEL), 1),
                          _createElementVNode("div", {
                            class: "admin-item-team-name",
                            onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.toggleSort('candidateName'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.NAME_LABEL) + " ", 1),
                            (_ctx.sortBy === 'candidateName' || _ctx.sortBy === '-candidateName')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-candidateName' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-team-email",
                            onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.toggleSort('email'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.EMAIL_LABEL) + " ", 1),
                            (_ctx.sortBy === 'email' || _ctx.sortBy === '-email')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-email' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-join-team-designation",
                            onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.toggleSort('designation'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.DESIGNATION_LABEL) + " ", 1),
                            (_ctx.sortBy === 'designation' || _ctx.sortBy === '-designation')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-designation' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-team-date",
                            onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.toggleSort('Created_at'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.DATE_LABEL) + " ", 1),
                            (
                            _ctx.sortBy === 'Created_at' ||
                            _ctx.sortBy === '-Created_at'
                          )
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { sorted: _ctx.sortBy === '-Created_at' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-ai-score",
                            onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.toggleSort('ai_score'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.AI_SCORE_LABEL) + " ", 1),
                            (_ctx.sortBy === 'ai_score' || _ctx.sortBy === '-ai_score')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-ai_score' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.constants.ACTIONS_LABEL), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editJoinTeamsData, (joinTeam, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: joinTeam.id,
                            class: _normalizeClass([
                        'admin-item-box',
                        { 'show-edit-item': joinTeam.editing },
                      ])
                          }, [
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("div", _hoisted_58, [
                                (joinTeam.status === 0 && !joinTeam.is_viewed)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_59))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_60, [
                                  _createElementVNode("div", _hoisted_61, [
                                    _createElementVNode("input", {
                                      name: "cssCheckbox",
                                      id: 'demo_opt_' + joinTeam.id,
                                      type: "checkbox",
                                      class: "css-checkbox",
                                      onChange: ($event: any) => (_ctx.toggleJoinTeamSelection(joinTeam.id)),
                                      checked: 
                                  _ctx.selectedJoinTeams.includes(joinTeam.id)
                                
                                    }, null, 40, _hoisted_62),
                                    _createElementVNode("label", {
                                      for: 'demo_opt_' + joinTeam.id
                                    }, null, 8, _hoisted_63)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_64, [
                                  _createElementVNode("div", _hoisted_65, [
                                    _createElementVNode("img", {
                                      src: 
                                  _ctx.getCdnImageAddress(
                                    joinTeam.candidateImage,
                                    `w_40,h_41/`
                                  )
                                ,
                                      alt: ""
                                    }, null, 8, _hoisted_66)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_67, [
                                  _createElementVNode("div", _hoisted_68, _toDisplayString(joinTeam.candidateName), 1)
                                ]),
                                _createElementVNode("div", _hoisted_69, _toDisplayString(joinTeam.email), 1),
                                _createElementVNode("div", _hoisted_70, _toDisplayString(joinTeam.designation), 1),
                                _createElementVNode("div", _hoisted_71, [
                                  (joinTeam.Created_at)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_72, [
                                        _createTextVNode(_toDisplayString(_ctx.formatDate(joinTeam.Created_at)), 1)
                                      ])), [
                                        [
                                          _directive_b_tooltip,
                                          {
                                title: _ctx.formatDate(joinTeam.Created_at),
                              },
                                          void 0,
                                          { up: true }
                                        ]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_73, [
                                  _createElementVNode("button", {
                                    class: "ai-score-popup-btn",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#aiScorePop",
                                    onClick: ($event: any) => (_ctx.openAiScorePopup(joinTeam))
                                  }, [
                                    _createTextVNode(_toDisplayString(_ctx.getAiScore(joinTeam)) + "% ", 1),
                                    _cache[90] || (_cache[90] = _createElementVNode("i", { class: "ai-score-popup-icon" }, null, -1))
                                  ], 8, _hoisted_74)
                                ]),
                                _createElementVNode("div", _hoisted_75, [
                                  _createElementVNode("ul", _hoisted_76, [
                                    _createElementVNode("li", null, [
                                      _createElementVNode("button", {
                                        id: "teamPgPublishBtn",
                                        class: "viewbtn",
                                        onClick: ($event: any) => (
                                    _ctx.dummyfunction(
                                      index,
                                      joinTeam.id,
                                      joinTeam.email
                                    )
                                  )
                                      }, _toDisplayString(_ctx.constants.VIEW_BUTTON), 9, _hoisted_77)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("button", {
                                        id: "joinTeamPgDwonloadBtn",
                                        onClick: ($event: any) => (
                                    _ctx.downloadResume(
                                      'single',
                                      joinTeam.id,
                                      joinTeam.candidateName
                                    )
                                  )
                                      }, _toDisplayString(_ctx.constants.DOWNLOAD_BUTTON), 9, _hoisted_78)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("button", {
                                        class: "hide-row-btn",
                                        id: "joinTeamPgDeleteBtn",
                                        "data-bs-toggle": "modal",
                                        "data-bs-target": "#deletePop",
                                        onClick: ($event: any) => (
                                    _ctx.setDeleteMode('single', joinTeam.id)
                                  )
                                      }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_79)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("div", _hoisted_80, [
                                        _createElementVNode("select", {
                                          id: 'statusSelectBox_' + joinTeam.id,
                                          class: "statusselectbox",
                                          onChange: ($event: any) => (_ctx.onStatusChange($event, joinTeam.id)),
                                          style: _normalizeStyle(_ctx.getStatusColor(joinTeam.status)),
                                          onClick: ($event: any) => (_ctx.personId(joinTeam.id))
                                        }, [
                                          _createElementVNode("option", {
                                            value: "pending",
                                            selected: joinTeam.status === 0
                                          }, " Pending ", 8, _hoisted_82),
                                          _createElementVNode("option", {
                                            value: "hired",
                                            selected: joinTeam.status === 1
                                          }, " Hired ", 8, _hoisted_83),
                                          _createElementVNode("option", {
                                            value: "rejected",
                                            selected: joinTeam.status === 2
                                          }, " Rejected ", 8, _hoisted_84),
                                          _createElementVNode("option", {
                                            value: "evaluating",
                                            selected: joinTeam.status === 4,
                                            disabled: ""
                                          }, " Evaluating ", 8, _hoisted_85)
                                        ], 44, _hoisted_81)
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            (joinTeam.editing)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                  _createElementVNode("div", _hoisted_87, [
                                    _createElementVNode("button", {
                                      class: "viewclose",
                                      id: "viewCloseBtn",
                                      onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.editFormSubmitted = false))
                                    }, [...(_cache[91] || (_cache[91] = [
                                      _createElementVNode("img", {
                                        src: _imports_1,
                                        alt: ""
                                      }, null, -1)
                                    ]))]),
                                    _createElementVNode("div", _hoisted_88, [
                                      _createElementVNode("div", _hoisted_89, [
                                        _createElementVNode("div", _hoisted_90, [
                                          _createElementVNode("img", {
                                            src: 
                                    _ctx.editimageSrc ||
                                    require('@/assets/images/admin-img/image-icon.svg')
                                  ,
                                            alt: ""
                                          }, null, 8, _hoisted_91)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_92, [
                                        _createElementVNode("div", _hoisted_93, [
                                          _createElementVNode("ul", null, [
                                            _createElementVNode("li", null, [
                                              _createElementVNode("label", null, _toDisplayString(_ctx.constants.NAME_LABEL) + ":", 1),
                                              _createElementVNode("span", _hoisted_94, _toDisplayString(joinTeam.candidateName), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _createElementVNode("label", null, _toDisplayString(_ctx.constants.DESIGNATION_LABEL) + ":", 1),
                                              _createElementVNode("span", _hoisted_95, _toDisplayString(joinTeam.designation), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _createElementVNode("label", null, _toDisplayString(_ctx.constants.DATE_LABEL) + ":", 1),
                                              _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.formatDate(joinTeam.Created_at)), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _createElementVNode("label", null, _toDisplayString(_ctx.constants.EMAIL_LABEL) + ":", 1),
                                              _createElementVNode("span", _hoisted_97, _toDisplayString(joinTeam.email), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _createElementVNode("label", null, _toDisplayString(_ctx.constants.NAME_OF_REFERENCE_LABEL) + ":", 1),
                                              _createElementVNode("span", _hoisted_98, _toDisplayString(joinTeam.nameOfReference), 1)
                                            ]),
                                            _createElementVNode("li", _hoisted_99, [
                                              _createElementVNode("div", _hoisted_100, [
                                                _createElementVNode("label", null, _toDisplayString(_ctx.constants.STATUS_LABEL) + ":", 1),
                                                _cache[92] || (_cache[92] = _createElementVNode("span", { class: "span-txt" }, [
                                                  _createElementVNode("div", { class: "status-in-view status-new" }, "New")
                                                ], -1))
                                              ]),
                                              _createElementVNode("div", _hoisted_101, [
                                                _createElementVNode("label", null, _toDisplayString(_ctx.constants.AI_SCORE_LABEL) + ":", 1),
                                                _createElementVNode("span", _hoisted_102, [
                                                  _createElementVNode("button", {
                                                    class: "ai-score-popup-btn",
                                                    "data-bs-toggle": "modal",
                                                    "data-bs-target": "#aiScorePop",
                                                    onClick: ($event: any) => (_ctx.openAiScorePopup(joinTeam))
                                                  }, [
                                                    _createTextVNode(_toDisplayString(_ctx.getAiScore(joinTeam)) + "% ", 1),
                                                    _cache[93] || (_cache[93] = _createElementVNode("i", { class: "ai-score-popup-icon" }, null, -1))
                                                  ], 8, _hoisted_103)
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("li", _hoisted_104, [
                                              _createElementVNode("label", null, _toDisplayString(_ctx.constants.DESCRIPTION_LABEL) + ":", 1),
                                              _createElementVNode("span", _hoisted_105, _toDisplayString(joinTeam.description), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _createElementVNode("label", null, _toDisplayString(_ctx.constants.ATTACHMENT_LABEL) + ":", 1),
                                              _createElementVNode("span", null, [
                                                _createElementVNode("div", _hoisted_106, [
                                                  _cache[95] || (_cache[95] = _createElementVNode("i", null, [
                                                    _createElementVNode("img", {
                                                      src: _imports_2,
                                                      alt: ""
                                                    })
                                                  ], -1)),
                                                  _createElementVNode("div", _hoisted_107, [
                                                    _createElementVNode("span", null, _toDisplayString(joinTeam.resumeName), 1),
                                                    _createElementVNode("span", null, _toDisplayString(joinTeam.resumeSize), 1)
                                                  ]),
                                                  _createElementVNode("button", {
                                                    class: "attachmentDownloadBtn",
                                                    onClick: ($event: any) => (_ctx.downloadResume('single', joinTeam.id))
                                                  }, [...(_cache[94] || (_cache[94] = [
                                                    _createElementVNode("img", {
                                                      src: _imports_3,
                                                      alt: ""
                                                    }, null, -1)
                                                  ]))], 8, _hoisted_108)
                                                ])
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _cache[96] || (_cache[96] = _createElementVNode("div", { class: "sender-actions" }, null, -1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_109, [
                                      _createElementVNode("h6", null, _toDisplayString(_ctx.constants.CONVERSATION_HISTORY_TEXT) + " : " + _toDisplayString(_ctx.emailThread.length), 1),
                                      _createElementVNode("ul", _hoisted_110, [
                                        _createElementVNode("li", null, [
                                          _createElementVNode("button", {
                                            id: "replyMailBtn",
                                            "data-bs-toggle": "modal",
                                            "data-bs-target": "#replyPop",
                                            onClick: ($event: any) => ((_ctx.candidateId = joinTeam.id), (_ctx.errMsg = ''))
                                          }, _toDisplayString(_ctx.constants.NEW_EMAIL_BUTTON), 9, _hoisted_111)
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createElementVNode("button", {
                                            id: "deleteMailBtn",
                                            "data-bs-toggle": "modal",
                                            "data-bs-target": "#deletePop",
                                            onClick: ($event: any) => (_ctx.setDeleteMode('single', joinTeam.id))
                                          }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_112)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_113, [
                                      _createElementVNode("div", _hoisted_114, [
                                        _createElementVNode("div", _hoisted_115, _toDisplayString(_ctx.constants.DATE_LABEL), 1),
                                        _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.constants.FROM_LABEL), 1),
                                        _createElementVNode("div", _hoisted_117, _toDisplayString(_ctx.constants.TO_LABEL), 1),
                                        _createElementVNode("div", _hoisted_118, _toDisplayString(_ctx.constants.SUBJECT_LABEL), 1),
                                        _createElementVNode("div", _hoisted_119, _toDisplayString(_ctx.constants.ACTION_LABEL), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_120, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailThread, (thread, index) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(["join-team-tabs-box", { 'tabs-open': thread.isOpen }]),
                                            key: index
                                          }, [
                                            _createElementVNode("button", {
                                              class: "collapse-btn",
                                              onClick: ($event: any) => (_ctx.toggleCollapse(index))
                                            }, null, 8, _hoisted_121),
                                            _createElementVNode("div", _hoisted_122, [
                                              _createElementVNode("div", _hoisted_123, [
                                                _createElementVNode("div", _hoisted_124, [
                                                  _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                                    _createTextVNode(_toDisplayString(_ctx.formatDate(thread.Created_at)), 1)
                                                  ])), [
                                                    [
                                                      _directive_b_tooltip,
                                                      {
                                          title: _ctx.formatDate(thread.Created_at),
                                        },
                                                      void 0,
                                                      { up: true }
                                                    ]
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_125, _toDisplayString(thread.email), 1),
                                                _createElementVNode("div", _hoisted_126, _toDisplayString(thread.to || 'hr@lmdconsulting.com'), 1),
                                                _createElementVNode("div", _hoisted_127, _toDisplayString(thread.subject), 1),
                                                _createElementVNode("div", _hoisted_128, [
                                                  _createElementVNode("ul", _hoisted_129, [
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("button", {
                                                        id: "deleteMailBtn",
                                                        "data-bs-toggle": "modal",
                                                        "data-bs-target": "#deletePop",
                                                        onClick: ($event: any) => (_ctx.setDeleteMode('emailThread', undefined, thread.id))
                                                      }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_130)
                                                    ])
                                                  ])
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_131, [
                                              _createElementVNode("div", _hoisted_132, [
                                                _createElementVNode("ul", null, [
                                                  _createElementVNode("li", null, [
                                                    _createElementVNode("div", _hoisted_133, [
                                                      _createElementVNode("label", null, _toDisplayString(_ctx.constants.FROM_LABEL) + ":", 1),
                                                      _createElementVNode("span", null, _toDisplayString(thread.email), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_134, _toDisplayString(_ctx.formatDate(thread.Created_at)), 1)
                                                  ]),
                                                  _createElementVNode("li", null, [
                                                    _createElementVNode("div", _hoisted_135, [
                                                      _createElementVNode("label", null, _toDisplayString(_ctx.constants.SUBJECT_LABEL) + ":", 1),
                                                      _createElementVNode("span", null, _toDisplayString(thread.subject), 1)
                                                    ])
                                                  ]),
                                                  _createElementVNode("li", null, [
                                                    _createElementVNode("div", _hoisted_136, [
                                                      _createElementVNode("label", null, _toDisplayString(_ctx.constants.TO_LABEL) + ":", 1),
                                                      _createElementVNode("span", null, _toDisplayString(thread.to || 'hr@lmdconsulting.com'), 1)
                                                    ])
                                                  ]),
                                                  _createElementVNode("li", null, [
                                                    _createElementVNode("div", _hoisted_137, [
                                                      _createElementVNode("p", {
                                                        innerHTML: thread.emailContent
                                                      }, null, 8, _hoisted_138)
                                                    ])
                                                  ]),
                                                  _createElementVNode("li", null, [
                                                    _createElementVNode("ul", _hoisted_139, [
                                                      _createElementVNode("li", null, [
                                                        _createElementVNode("button", {
                                                          id: "replyMailBtn",
                                                          "data-bs-toggle": "modal",
                                                          "data-bs-target": "#replyPop",
                                                          onClick: ($event: any) => ((_ctx.candidateId = joinTeam.id), (_ctx.errMsg = ''))
                                                        }, _toDisplayString(_ctx.constants.REPLY_BUTTON), 9, _hoisted_140)
                                                      ]),
                                                      _createElementVNode("li", null, [
                                                        _createElementVNode("button", {
                                                          id: "deleteMailBtn",
                                                          "data-bs-toggle": "modal",
                                                          "data-bs-target": "#deletePop",
                                                          onClick: ($event: any) => (_ctx.setDeleteMode('emailThread', undefined, thread.id))
                                                        }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_141)
                                                      ])
                                                    ])
                                                  ])
                                                ])
                                              ])
                                            ])
                                          ], 2))
                                        }), 128))
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 2))
                        }), 128))
                      ])
                    ])
                  ], 512),
                  _createElementVNode("div", _hoisted_142, [
                    _createElementVNode("div", _hoisted_143, [
                      _createElementVNode("div", _hoisted_144, [
                        _withDirectives(_createElementVNode("select", {
                          id: "paginationSelectBox",
                          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.limit) = $event)),
                          onChange: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.handleLimitChange && _ctx.handleLimitChange(...args)))
                        }, [...(_cache[97] || (_cache[97] = [
                          _createElementVNode("option", { value: "10" }, "10", -1),
                          _createElementVNode("option", { value: "20" }, "20", -1),
                          _createElementVNode("option", { value: "50" }, "50", -1),
                          _createElementVNode("option", { value: "100" }, "100", -1)
                        ]))], 544), [
                          [_vModelSelect, _ctx.limit]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.ENTRIES_PER_PAGE_LABEL), 1)
                      ]),
                      (_ctx.totalPages > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                            _createElementVNode("ul", null, [
                              (_ctx.currentPage !== 1)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 0,
                                    onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                                  }, [...(_cache[98] || (_cache[98] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-previous"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              (_ctx.totalPages != 1)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.visiblePages, (page) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: page,
                                      onClick: ($event: any) => (_ctx.changePage(page))
                                    }, [
                                      _createElementVNode("a", {
                                        href: "#",
                                        class: _normalizeClass({ active: _ctx.currentPage === page })
                                      }, _toDisplayString(page), 3)
                                    ], 8, _hoisted_146))
                                  }), 128))
                                : _createCommentVNode("", true),
                              (_ctx.currentPage !== _ctx.totalPages)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 2,
                                    onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                                  }, [...(_cache[99] || (_cache[99] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-next"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_147, [...(_cache[100] || (_cache[100] = [
                  _createElementVNode("p", null, "No data to display", -1)
                ]))]))
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_148, [
      _createElementVNode("div", _hoisted_149, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ]),
    _createElementVNode("div", _hoisted_150, [
      _createElementVNode("div", _hoisted_151, [
        _createElementVNode("div", _hoisted_152, [
          _cache[101] || (_cache[101] = _createElementVNode("div", { class: "confirmation-popup-icon" }, [
            _createElementVNode("i", null, [
              _createElementVNode("img", {
                src: _imports_4,
                alt: ""
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_153, [
            _createElementVNode("p", null, _toDisplayString(_ctx.constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT), 1)
          ]),
          _createElementVNode("div", _hoisted_154, [
            _createElementVNode("button", _hoisted_155, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_156, [
      _createElementVNode("div", _hoisted_157, [
        _createElementVNode("div", _hoisted_158, [
          _cache[102] || (_cache[102] = _createElementVNode("div", { class: "confirmation-popup-icon" }, [
            _createElementVNode("i", null, [
              _createElementVNode("img", {
                src: _imports_5,
                alt: ""
              })
            ])
          ], -1)),
          _cache[103] || (_cache[103] = _createElementVNode("div", { class: "confirmation-popup-mid" }, " Are you sure, you want to change the status to pending? ", -1)),
          _createElementVNode("div", _hoisted_159, [
            _createElementVNode("button", {
              id: "popNoBtn",
              class: "admin-btn-outline-secondary",
              "data-bs-dismiss": "modal",
              onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.resetStatus && _ctx.resetStatus(...args)))
            }, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.confirmStatusChange()))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_160, [
      _createElementVNode("div", _hoisted_161, [
        _createElementVNode("div", _hoisted_162, [
          _cache[104] || (_cache[104] = _createElementVNode("div", { class: "confirmation-popup-icon" }, [
            _createElementVNode("i", null, [
              _createElementVNode("img", {
                src: _imports_6,
                alt: ""
              })
            ])
          ], -1)),
          _cache[105] || (_cache[105] = _createElementVNode("div", { class: "confirmation-popup-mid" }, " Are you sure, you want to hire this? ", -1)),
          _createElementVNode("div", _hoisted_163, [
            _createElementVNode("button", {
              id: "popNoBtn",
              class: "admin-btn-outline-secondary",
              "data-bs-dismiss": "modal",
              onClick: _cache[59] || (_cache[59] = 
//@ts-ignore
(...args) => (_ctx.resetStatus && _ctx.resetStatus(...args)))
            }, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.confirmStatusChange()))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_164, [
      _createElementVNode("div", _hoisted_165, [
        _createElementVNode("div", _hoisted_166, [
          _cache[106] || (_cache[106] = _createElementVNode("div", { class: "confirmation-popup-icon" }, [
            _createElementVNode("i", null, [
              _createElementVNode("img", {
                src: _imports_7,
                alt: ""
              })
            ])
          ], -1)),
          _cache[107] || (_cache[107] = _createElementVNode("div", { class: "confirmation-popup-mid" }, " Are you sure, you want to rejected this? ", -1)),
          _createElementVNode("div", _hoisted_167, [
            _createElementVNode("button", {
              id: "popNoBtn",
              class: "admin-btn-outline-secondary",
              "data-bs-dismiss": "modal",
              onClick: _cache[61] || (_cache[61] = 
//@ts-ignore
(...args) => (_ctx.resetStatus && _ctx.resetStatus(...args)))
            }, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.confirmStatusChange()))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_168, [
      _createElementVNode("div", _hoisted_169, [
        _createElementVNode("div", _hoisted_170, [
          _cache[108] || (_cache[108] = _createElementVNode("button", {
            class: "reply-pop-close",
            "data-bs-dismiss": "modal",
            id: "replyPopCloseBtn"
          }, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: ""
            })
          ], -1)),
          _createElementVNode("h2", null, "Reply to " + _toDisplayString(_ctx.editJoinTeamData.candidateName), 1),
          _createElementVNode("div", _hoisted_171, [
            _createElementVNode("form", {
              id: "emailReplyForm",
              onSubmit: _cache[68] || (_cache[68] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_172, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.NAME_LABEL), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "replyNameInput",
                  type: "text",
                  placeholder: "Enter the Name",
                  "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.editJoinTeamData.candidateName) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.editJoinTeamData.candidateName]
                ])
              ]),
              _createElementVNode("div", _hoisted_173, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.EMAIL_LABEL), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "replyNameInput",
                  type: "text",
                  placeholder: "Enter the Email",
                  "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.editJoinTeamData.email) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.editJoinTeamData.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_174, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.SUBJECT_LABEL), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "replyNameInput",
                  type: "text",
                  placeholder: "Enter the Subject",
                  "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.newEmail.subject) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.newEmail.subject]
                ]),
                (!_ctx.newEmail.subject)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_175, _toDisplayString(_ctx.errMsg), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_176, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.DESCRIPTION_LABEL), 1),
                _createVNode(_component_ckeditor, {
                  placeholder: "Description",
                  class: "text-editer",
                  id: "replyDescInput",
                  editor: _ctx.editor,
                  modelValue: _ctx.newEmail.description,
                  "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.newEmail.description) = $event)),
                  config: _ctx.editorConfig
                }, null, 8, ["editor", "modelValue", "config"]),
                (!_ctx.newEmail.description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_177, _toDisplayString(_ctx.errMsg), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_178, [
                _createElementVNode("button", {
                  id: "servicesPgSubmitBtn",
                  type: "submit",
                  class: "admin-btn-outline-primary",
                  disabled: _ctx.isSubmitting
                }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_179),
                _createElementVNode("button", _hoisted_180, null, 512),
                _createElementVNode("button", {
                  id: "servicesPgSubmitBtn",
                  type: "button",
                  class: "admin-btn-outline-secondary",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[67] || (_cache[67] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)), ["prevent"]))
                }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_181, [
      _createElementVNode("div", _hoisted_182, [
        _createElementVNode("div", _hoisted_183, [
          _cache[118] || (_cache[118] = _createElementVNode("button", {
            class: "ai-score-pop-close",
            "data-bs-dismiss": "modal",
            id: "replyPopCloseBtn"
          }, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: ""
            })
          ], -1)),
          _createElementVNode("div", _hoisted_184, [
            _createElementVNode("div", _hoisted_185, [
              _createElementVNode("div", _hoisted_186, [
                _createElementVNode("div", _hoisted_187, [
                  _createElementVNode("img", {
                    src: _ctx.selectedCandidate?.candidateImage ? _ctx.getCdnImageAddress(_ctx.selectedCandidate.candidateImage, 'w_80,h_80/') : require('@/assets/images/admin-img/image-icon.svg'),
                    alt: ""
                  }, null, 8, _hoisted_188)
                ]),
                _createElementVNode("div", _hoisted_189, [
                  _createElementVNode("div", _hoisted_190, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.selectedCandidate?.candidateName), 1),
                    _createElementVNode("div", {
                      class: "status-in-view",
                      style: _normalizeStyle(_ctx.getStatusColor(_ctx.selectedCandidate?.status))
                    }, _toDisplayString(_ctx.getStatusText(_ctx.selectedCandidate?.status)), 5)
                  ]),
                  _createElementVNode("div", _hoisted_191, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.constants.APPLIED_FOR_JOB_TEXT), 1),
                    _createElementVNode("h5", null, _toDisplayString(_ctx.selectedCandidate?.designation), 1)
                  ]),
                  _createElementVNode("div", _hoisted_192, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.constants.APPLICATION_SUBMITTED_TEXT), 1),
                    _createElementVNode("h5", null, _toDisplayString(_ctx.formatDate(_ctx.selectedCandidate?.Created_at)), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_193, [
              _createElementVNode("div", {
                class: _normalizeClass(["ai-score-status-box", `ai-score-status-box-${_ctx.currentScoreColor}`])
              }, [
                _createElementVNode("div", _hoisted_194, [
                  (_openBlock(), _createElementBlock("svg", {
                    viewBox: "0 0 36 36",
                    class: _normalizeClass(`circular-chart circular-chart-${_ctx.currentScoreColor}`)
                  }, [
                    _cache[109] || (_cache[109] = _createElementVNode("path", {
                      class: "circle-bg",
                      d: "M18 2.0845\n                  a 15.9155 15.9155 0 0 1 0 31.831\n                  a 15.9155 15.9155 0 0 1 0 -31.831"
                    }, null, -1)),
                    _createElementVNode("path", {
                      class: "circle",
                      "stroke-dasharray": `${_ctx.currentScore}, 100`,
                      d: "M18 2.0845\n                  a 15.9155 15.9155 0 0 1 0 31.831\n                  a 15.9155 15.9155 0 0 1 0 -31.831"
                    }, null, 8, _hoisted_195),
                    _createElementVNode("text", _hoisted_196, _toDisplayString(_ctx.currentScore) + "%", 1)
                  ], 2))
                ]),
                _createElementVNode("div", _hoisted_197, [
                  _cache[110] || (_cache[110] = _createElementVNode("h5", null, "Job Match Score", -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.currentScoreText), 1),
                  _createElementVNode("p", null, "Processed using version " + _toDisplayString(_ctx.getLatestEvaluation(_ctx.selectedCandidate)?.criteria_version), 1)
                ])
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_198, [
            _createElementVNode("div", _hoisted_199, [
              _createElementVNode("div", _hoisted_200, [
                _createElementVNode("ul", _hoisted_201, [
                  _createElementVNode("li", _hoisted_202, [
                    _createElementVNode("button", _hoisted_203, _toDisplayString(_ctx.constants.SCORE_OVERRIDE_BUTTON), 1)
                  ]),
                  _createElementVNode("li", _hoisted_204, [
                    _createElementVNode("button", _hoisted_205, _toDisplayString(_ctx.constants.OVERRIDE_HISTORY_BUTTON), 1)
                  ]),
                  _createElementVNode("li", _hoisted_206, [
                    _createElementVNode("button", _hoisted_207, _toDisplayString(_ctx.constants.RESUME_BUTTON), 1)
                  ]),
                  _createElementVNode("li", _hoisted_208, [
                    _createElementVNode("button", _hoisted_209, _toDisplayString(_ctx.constants.CRITERIA_TEXT), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_210, [
                _createElementVNode("div", _hoisted_211, [
                  _createElementVNode("div", _hoisted_212, [
                    _createElementVNode("div", _hoisted_213, [
                      _createElementVNode("div", {
                        class: "score-override-tab-details-step-1",
                        style: _normalizeStyle({ display: _ctx.showStep1 ? 'block' : 'none' })
                      }, [
                        _createElementVNode("div", _hoisted_214, [
                          _createElementVNode("div", _hoisted_215, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.displayScoreSummary), 1),
                            (_ctx.shouldShowReadMore)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "read-more-link",
                                  onClick: _cache[69] || (_cache[69] = 
//@ts-ignore
(...args) => (_ctx.toggleScoreSummary && _ctx.toggleScoreSummary(...args)))
                                }, _toDisplayString(_ctx.isScoreSummaryExpanded ? _ctx.constants.SHOW_LESS_LINK : _ctx.constants.READ_MORE_LINK), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_216, [
                          _createElementVNode("div", _hoisted_217, [
                            _createVNode(_component_Carousel, {
                              itemsToShow: 4,
                              wrapAround: false,
                              transition: 300,
                              snapAlign: 'start'
                            }, {
                              addons: _withCtx(() => [
                                _createVNode(_component_Navigation)
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableReviewers, (reviewer) => {
                                  return (_openBlock(), _createBlock(_component_Slide, {
                                    key: reviewer,
                                    class: _normalizeClass({ active: _ctx.activeReviewer === reviewer })
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (_ctx.switchReviewer(reviewer))
                                      }, _toDisplayString(reviewer), 9, _hoisted_218)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", {
                            class: "scores-edit-section",
                            style: _normalizeStyle({ display: _ctx.isOverallScoreExpanded ? 'none' : 'block' })
                          }, [
                            _createElementVNode("div", _hoisted_219, [
                              _createElementVNode("div", _hoisted_220, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentScoreBreakdown, ([key, breakdown]) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "scores-edit-box",
                                    key: `${_ctx.activeReviewer}-${key}`
                                  }, [
                                    _createElementVNode("div", _hoisted_221, [
                                      _createElementVNode("div", _hoisted_222, [
                                        _createElementVNode("div", _hoisted_223, _toDisplayString(_ctx.getBreakdownLabel(key)), 1),
                                        _createElementVNode("div", _hoisted_224, _toDisplayString(breakdown.score) + "%", 1)
                                      ]),
                                      _createElementVNode("div", {
                                        class: "scores-edit-progress-bar",
                                        style: _normalizeStyle(`background-color: ${_ctx.getScoreColor(breakdown.score).background};`)
                                      }, [
                                        _createElementVNode("span", {
                                          class: "scores-edit-progress-done",
                                          style: _normalizeStyle(`width: ${breakdown.score}%; background-color: ${_ctx.getScoreColor(breakdown.score).progress};`)
                                        }, null, 4)
                                      ], 4)
                                    ]),
                                    _createElementVNode("div", _hoisted_225, [
                                      _createElementVNode("ul", _hoisted_226, [
                                        _createElementVNode("li", null, [
                                          _createElementVNode("button", {
                                            class: "scores-edit-icon",
                                            onClick: ($event: any) => (_ctx.editSingleScore(key))
                                          }, null, 8, _hoisted_227)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_228, [
                                      _createElementVNode("ul", null, [
                                        _createElementVNode("li", null, [
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.getWeightedScore(key)), 1),
                                          _cache[111] || (_cache[111] = _createTextVNode("AI Weight", -1))
                                        ]),
                                        _createElementVNode("li", null, [
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.getOriginalWeight(key)), 1),
                                          _cache[112] || (_cache[112] = _createTextVNode("Original Weight", -1))
                                        ])
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ], 512),
                            (!_ctx.isOverallScoreExpanded)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "edit-all-scores-btn",
                                  onClick: _cache[70] || (_cache[70] = 
//@ts-ignore
(...args) => (_ctx.editAllScores && _ctx.editAllScores(...args)))
                                }, [
                                  _createElementVNode("button", null, _toDisplayString(_ctx.constants.EDIT_ALL_SCORES_BUTTON), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ], 4),
                          _createElementVNode("div", {
                            class: "over-all-score-chart",
                            style: _normalizeStyle({ display: _ctx.isOverallScoreExpanded ? 'block' : 'none' })
                          }, [
                            _createElementVNode("canvas", _hoisted_229, null, 512)
                          ], 4)
                        ])
                      ], 4),
                      _createElementVNode("div", {
                        class: "score-override-tab-details-step-2",
                        style: _normalizeStyle({ display: _ctx.showStep1 ? 'none' : 'block' })
                      }, [
                        _createElementVNode("div", _hoisted_230, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.INTERVIEWER_NAME_LABEL), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            placeholder: "Enter the Interviewer Name",
                            "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.editedScore.reviewer_name) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.editedScore.reviewer_name]
                          ]),
                          (_ctx.reviewerNameError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_231, _toDisplayString(_ctx.reviewerNameError), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_232, [
                          _createElementVNode("div", _hoisted_233, [
                            _createElementVNode("div", _hoisted_234, [
                              _createElementVNode("div", {
                                class: "score-override-edit-single-reason",
                                style: _normalizeStyle({ display: _ctx.editScoreType === 'single' ? 'block' : 'none' })
                              }, [
                                _createElementVNode("div", _hoisted_235, [
                                  _createElementVNode("div", _hoisted_236, [
                                    _createElementVNode("div", _hoisted_237, [
                                      _createElementVNode("div", _hoisted_238, [
                                        _createElementVNode("h4", null, _toDisplayString(_ctx.selectedReasonKey ? _ctx.getBreakdownLabel(_ctx.selectedReasonKey) : ''), 1),
                                        _createElementVNode("span", _hoisted_239, _toDisplayString(_ctx.getEditedScore(_ctx.selectedReasonKey)) + "%", 1)
                                      ]),
                                      _createElementVNode("div", {
                                        class: "score-override-edit-reason-left-btm",
                                        style: _normalizeStyle(`background-color: ${_ctx.getScoreColor(_ctx.getEditedScore(_ctx.selectedReasonKey)).background};`)
                                      }, [
                                        _createElementVNode("span", {
                                          style: _normalizeStyle(`width: ${_ctx.getEditedScore(_ctx.selectedReasonKey)}%; background-color: ${_ctx.getScoreColor(_ctx.getEditedScore(_ctx.selectedReasonKey)).progress};`),
                                          class: "progress-bar-done"
                                        }, null, 4)
                                      ], 4)
                                    ]),
                                    _createElementVNode("div", _hoisted_240, [
                                      _createElementVNode("input", {
                                        type: "number",
                                        id: "newScoreinput",
                                        min: "0",
                                        max: "100",
                                        step: "1",
                                        name: "score",
                                        placeholder: "Enter Score(0-100)",
                                        value: _ctx.getEditedScore(_ctx.selectedReasonKey),
                                        onInput: _cache[72] || (_cache[72] = ($event: any) => (_ctx.updateEditedScore(_ctx.selectedReasonKey, $event)))
                                      }, null, 40, _hoisted_241),
                                      (_ctx.scoreErrors[_ctx.selectedReasonKey])
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_242, _toDisplayString(_ctx.scoreErrors[_ctx.selectedReasonKey]), 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_243, [
                                    _createElementVNode("label", null, _toDisplayString(_ctx.constants.FEEDBACK_SUMMARY_LABEL), 1),
                                    _createElementVNode("div", _hoisted_244, [
                                      _createElementVNode("textarea", {
                                        value: _ctx.getEditedFeedback(_ctx.selectedReasonKey),
                                        onInput: _cache[73] || (_cache[73] = ($event: any) => (_ctx.updateEditedFeedback(_ctx.selectedReasonKey, $event))),
                                        placeholder: "Enter feedback",
                                        rows: "3"
                                      }, null, 40, _hoisted_245)
                                    ])
                                  ])
                                ])
                              ], 4),
                              _createElementVNode("div", {
                                class: "score-override-edit-multi-reason",
                                style: _normalizeStyle({ display: _ctx.editScoreType === 'multiple' ? 'block' : 'none' })
                              }, [
                                _createElementVNode("div", _hoisted_246, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedScoreBreakdown, ([key, breakdown]) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "accordion-item",
                                      key: key
                                    }, [
                                      _createElementVNode("h2", {
                                        class: "accordion-header",
                                        id: 'heading-' + key
                                      }, [
                                        _createElementVNode("button", {
                                          class: _normalizeClass(["accordion-button", { collapsed: !_ctx.expandedItems[key] }]),
                                          type: "button",
                                          onClick: ($event: any) => (_ctx.toggleAccordion(key)),
                                          "aria-expanded": _ctx.expandedItems[key],
                                          "aria-controls": 'collapse-' + key
                                        }, _toDisplayString(_ctx.getBreakdownLabel(key)), 11, _hoisted_248)
                                      ], 8, _hoisted_247),
                                      _createElementVNode("div", {
                                        id: 'collapse-' + key,
                                        class: _normalizeClass(["accordion-collapse", { collapse: !_ctx.expandedItems[key], show: _ctx.expandedItems[key] }]),
                                        "aria-labelledby": 'heading-' + key,
                                        "data-bs-parent": "#accordionExample"
                                      }, [
                                        _createElementVNode("div", _hoisted_250, [
                                          _createElementVNode("div", _hoisted_251, [
                                            _createElementVNode("div", _hoisted_252, [
                                              _createElementVNode("div", _hoisted_253, [
                                                _createElementVNode("div", _hoisted_254, [
                                                  _createElementVNode("h4", null, _toDisplayString(_ctx.getBreakdownLabel(key)), 1),
                                                  _createElementVNode("span", _hoisted_255, _toDisplayString(_ctx.scoreUpdates[key]) + "%", 1)
                                                ]),
                                                _createElementVNode("div", {
                                                  class: "score-override-edit-reason-left-btm",
                                                  style: _normalizeStyle(`background-color: ${_ctx.getScoreColor(parseInt(_ctx.scoreUpdates[key]) || 0).background};`)
                                                }, [
                                                  _createElementVNode("span", {
                                                    style: _normalizeStyle(`width: ${_ctx.scoreUpdates[key]}%; background-color: ${_ctx.getScoreColor(parseInt(_ctx.scoreUpdates[key]) || 0).progress};`),
                                                    class: "progress-bar-done"
                                                  }, null, 4)
                                                ], 4)
                                              ]),
                                              _createElementVNode("div", _hoisted_256, [
                                                _createElementVNode("input", {
                                                  type: "number",
                                                  id: 'newScoreinput-' + key,
                                                  name: "score",
                                                  min: "0",
                                                  max: "100",
                                                  step: "1",
                                                  placeholder: "Enter Score",
                                                  value: _ctx.scoreUpdates[key],
                                                  onInput: ($event: any) => (_ctx.updateScoreInput(key, $event))
                                                }, null, 40, _hoisted_257),
                                                (_ctx.scoreErrors[key])
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_258, _toDisplayString(_ctx.scoreErrors[key]), 1))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_259, [
                                              _createElementVNode("label", null, _toDisplayString(_ctx.constants.FEEDBACK_SUMMARY_LABEL), 1),
                                              _createElementVNode("div", _hoisted_260, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                  "onUpdate:modelValue": ($event: any) => ((_ctx.feedbackUpdates[key]) = $event),
                                                  placeholder: "Enter feedback"
                                                }, null, 8, _hoisted_261), [
                                                  [_vModelText, _ctx.feedbackUpdates[key]]
                                                ])
                                              ])
                                            ])
                                          ])
                                        ])
                                      ], 10, _hoisted_249)
                                    ]))
                                  }), 128))
                                ])
                              ], 4)
                            ])
                          ])
                        ], 512),
                        (_ctx.editScoreType === 'single' || _ctx.editScoreType === 'multiple')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_262, [
                              _createElementVNode("button", {
                                class: "admin-btn-outline-primary",
                                onClick: _cache[74] || (_cache[74] = 
//@ts-ignore
(...args) => (_ctx.submitReviewerScore && _ctx.submitReviewerScore(...args)))
                              }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 1),
                              _createElementVNode("button", {
                                class: "admin-btn-outline-secondary",
                                onClick: _cache[75] || (_cache[75] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                              }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 4)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_263, [
                    _createElementVNode("div", _hoisted_264, [
                      _createElementVNode("div", _hoisted_265, [
                        (_ctx.scoreHistory.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.scoreHistory, (historyItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "score-history-box",
                                key: historyItem.id
                              }, [
                                _createElementVNode("span", _hoisted_266, _toDisplayString(_ctx.formatDate(historyItem.date)), 1),
                                _createElementVNode("h4", null, _toDisplayString(historyItem.description), 1),
                                _cache[113] || (_cache[113] = _createElementVNode("span", { class: "score-history-reason" }, "Here's the reason.", -1)),
                                _createElementVNode("div", _hoisted_267, [
                                  _createElementVNode("p", null, _toDisplayString(historyItem.reason), 1)
                                ])
                              ]))
                            }), 128))
                          : (_openBlock(), _createElementBlock("div", _hoisted_268, [...(_cache[114] || (_cache[114] = [
                              _createElementVNode("p", { class: "no-data" }, "No score overriden history available.", -1)
                            ]))]))
                      ])
                    ], 512)
                  ]),
                  _createElementVNode("div", _hoisted_269, [
                    _createElementVNode("div", _hoisted_270, [
                      _createElementVNode("div", _hoisted_271, [
                        (_ctx.getResumeSections(_ctx.selectedCandidate))
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getResumeSections(_ctx.selectedCandidate), (section, key) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "score-resume-box",
                                key: key
                              }, [
                                _createElementVNode("h4", null, _toDisplayString(_ctx.formatSectionKey(key)), 1),
                                _createElementVNode("div", _hoisted_272, [
                                  (typeof section === 'string')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_273, _toDisplayString(section), 1))
                                    : (Array.isArray(section) && _ctx.isArrayOfStrings(section))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_274, [
                                          _createElementVNode("ul", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section, (item, index) => {
                                              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
                                            }), 128))
                                          ])
                                        ]))
                                      : (Array.isArray(section))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_275, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section, (item, index) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: index,
                                                class: "score-resume-box-desc"
                                              }, [
                                                (item.degree)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_276, [
                                                      _createElementVNode("h5", null, _toDisplayString(item.degree) + " from " + _toDisplayString(item.institution), 1),
                                                      _createElementVNode("span", _hoisted_277, _toDisplayString(item.year) + " (GPA: " + _toDisplayString(item.gpa) + ")", 1)
                                                    ]))
                                                  : (item.company)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_278, [
                                                        _createElementVNode("h5", null, _toDisplayString(item.company) + " | " + _toDisplayString(item.position), 1),
                                                        _createElementVNode("span", _hoisted_279, _toDisplayString(item.duration), 1),
                                                        (Array.isArray(item.description))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_280, [
                                                              _createElementVNode("ul", null, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.description, (desc, descIndex) => {
                                                                  return (_openBlock(), _createElementBlock("li", { key: descIndex }, _toDisplayString(desc), 1))
                                                                }), 128))
                                                              ])
                                                            ]))
                                                          : (_openBlock(), _createElementBlock("p", _hoisted_281, _toDisplayString(item.description), 1))
                                                      ]))
                                                    : (item.name && item.description && item.technologies)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_282, [
                                                          _createElementVNode("h5", null, _toDisplayString(item.name), 1),
                                                          _createElementVNode("p", null, _toDisplayString(item.description), 1),
                                                          _createElementVNode("div", _hoisted_283, [
                                                            _cache[115] || (_cache[115] = _createTextVNode(" Technologies: ", -1)),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.technologies, (tech, techIndex) => {
                                                              return (_openBlock(), _createElementBlock("span", { key: techIndex }, _toDisplayString(tech) + _toDisplayString(techIndex < item.technologies.length - 1 ? ', ' : ''), 1))
                                                            }), 128))
                                                          ]),
                                                          _createElementVNode("span", _hoisted_284, _toDisplayString(item.duration), 1)
                                                        ]))
                                                      : (item.name && item.issuer)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_285, [
                                                            _createElementVNode("h5", null, _toDisplayString(item.name), 1),
                                                            _createElementVNode("span", _hoisted_286, _toDisplayString(item.issuer) + " - " + _toDisplayString(item.year), 1)
                                                          ]))
                                                        : (item.name && item.description && !item.technologies)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_287, [
                                                              _createElementVNode("h5", null, _toDisplayString(item.name), 1),
                                                              _createElementVNode("p", null, _toDisplayString(item.description), 1)
                                                            ]))
                                                          : (_openBlock(), _createElementBlock("pre", _hoisted_288, _toDisplayString(JSON.stringify(item, null, 2)), 1))
                                              ]))
                                            }), 128))
                                          ]))
                                        : (_openBlock(), _createElementBlock("pre", _hoisted_289, _toDisplayString(JSON.stringify(section, null, 2)), 1))
                                ])
                              ]))
                            }), 128))
                          : (_openBlock(), _createElementBlock("div", _hoisted_290, [...(_cache[116] || (_cache[116] = [
                              _createElementVNode("p", { class: "no-data" }, "No resume sections available.", -1)
                            ]))]))
                      ])
                    ], 512)
                  ]),
                  _createElementVNode("div", _hoisted_291, [
                    _createElementVNode("div", _hoisted_292, [
                      _createElementVNode("div", _hoisted_293, [
                        _createElementVNode("div", _hoisted_294, [
                          (_ctx.getCriteria(_ctx.selectedCandidate))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_295, [
                                _createElementVNode("div", {
                                  innerHTML: _ctx.formatCriteriaText(_ctx.getCriteria(_ctx.selectedCandidate))
                                }, null, 8, _hoisted_296),
                                _createElementVNode("div", _hoisted_297, " Version : " + _toDisplayString(_ctx.getLatestEvaluation(_ctx.selectedCandidate)?.criteria_version), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_298, [...(_cache[117] || (_cache[117] = [
                                _createElementVNode("p", { class: "no-data" }, "No criteria available for this candidate.", -1)
                              ]))]))
                        ])
                      ], 512)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_299, [
      _createElementVNode("div", _hoisted_300, [
        _createElementVNode("div", _hoisted_301, [
          _cache[120] || (_cache[120] = _createElementVNode("div", {
            class: "criteria-pop-close",
            "data-bs-dismiss": "modal"
          }, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: ""
            })
          ], -1)),
          _createElementVNode("div", _hoisted_302, [
            _createElementVNode("div", _hoisted_303, [
              _createElementVNode("label", _hoisted_304, [
                _cache[119] || (_cache[119] = _createTextVNode("Add Criteria ", -1)),
                _createElementVNode("span", null, "Version : " + _toDisplayString(_ctx.criteriaForm.version) + "   Last created : " + _toDisplayString(_ctx.formatDate(_ctx.criteriaForm.created_at)), 1)
              ]),
              _withDirectives(_createElementVNode("textarea", {
                placeholder: "Enter the Criteria",
                "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.criteriaForm.criteria) = $event)),
                onInput: _cache[77] || (_cache[77] = 
//@ts-ignore
(...args) => (_ctx.clearCriteriaError && _ctx.clearCriteriaError(...args)))
              }, null, 544), [
                [_vModelText, _ctx.criteriaForm.criteria]
              ]),
              (_ctx.criteriaError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_305, _toDisplayString(_ctx.criteriaError), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_306, [
              _createElementVNode("button", {
                class: "admin-btn-outline-primary",
                onClick: _cache[78] || (_cache[78] = 
//@ts-ignore
(...args) => (_ctx.openConfirmationModal && _ctx.openConfirmationModal(...args)))
              }, _toDisplayString(_ctx.isSubmittingCriteria ? 'Submitting...' : _ctx.constants.SUBMIT_BUTTON), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_307, [
      _createElementVNode("div", _hoisted_308, [
        _createElementVNode("div", _hoisted_309, [
          _createElementVNode("div", _hoisted_310, _toDisplayString(_ctx.constants.ARE_YOU_SURE_YOU_WANT_TO_CREATE_NEW_VERSION_OF_CRITERIA_TEXT), 1),
          _createElementVNode("div", _hoisted_311, [
            _createElementVNode("button", {
              id: "popNoBtn",
              class: "admin-btn-outline-secondary",
              onClick: _cache[79] || (_cache[79] = 
//@ts-ignore
(...args) => (_ctx.handleNoClick && _ctx.handleNoClick(...args)))
            }, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              onClick: _cache[80] || (_cache[80] = 
//@ts-ignore
(...args) => (_ctx.submitCriteria && _ctx.submitCriteria(...args)))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_312, [
      _createElementVNode("div", _hoisted_313, [
        _createElementVNode("div", _hoisted_314, [
          _cache[121] || (_cache[121] = _createElementVNode("div", { class: "pop_header" }, [
            _createElementVNode("button", {
              class: "pop__close__btn",
              "data-bs-dismiss": "modal"
            }, [
              _createElementVNode("img", {
                src: _imports_1,
                alt: ""
              })
            ]),
            _createElementVNode("h1", null, "Select any one criteria to reproduce AI Score")
          ], -1)),
          _createElementVNode("div", _hoisted_315, [
            _createElementVNode("div", _hoisted_316, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.criteriaVersions, (criteria) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: criteria.id,
                  class: "reproduct-aiScore-v-list-item"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: `version${criteria.version}`,
                    name: "criteriaVersion",
                    value: criteria.id,
                    "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.selectedCriteriaVersion) = $event))
                  }, null, 8, _hoisted_317), [
                    [_vModelRadio, _ctx.selectedCriteriaVersion]
                  ]),
                  _createElementVNode("label", {
                    for: `version${criteria.version}`
                  }, "Version " + _toDisplayString(criteria.version), 9, _hoisted_318)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_319, [
              _createElementVNode("button", {
                class: "admin-btn-outline-primary",
                onClick: _cache[82] || (_cache[82] = 
//@ts-ignore
(...args) => (_ctx.reproduceAiScores && _ctx.reproduceAiScores(...args))),
                disabled: _ctx.isReproducing
              }, [
                (_ctx.isReproducing)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_321, "Reproducing..."))
                  : (_openBlock(), _createElementBlock("span", _hoisted_322, "Reproduce"))
              ], 8, _hoisted_320)
            ])
          ])
        ])
      ])
    ])
  ]))
}